import logistics from './logistics.vue'
export default logistics
